/*eslint-disable */
import { bus } from '@/main';
import toast from '@/services/toast';
export default {
  name: 'usr-req-send-popup',
  components: {},
  props: ['reqUsrInfo'],
  data () {
    return {
      isSubmitted:false,
      usrReqStep:true,
      message:'',
      selfUserId:''
    }
  },
  computed: {

  },
  mounted () {
    this.selfUserId = localStorage.getItem('LoginedUserID');
  },
  methods: {
    connectionReqFirstStepMethod(){
     this.usrReqStep = false 
    },
    sendChatReqConfirmMethod(e) {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.submitted = true;
            let data = {
              from_user:this.selfUserId,
              to_user:this.reqUsrInfo.id,
              message:this.message,
            }
            this.$store.dispatch('sendConnectionReqAction', data)
              .then((res) => {
                  toast.success(res.data.user_msg || res.data.msg);
              }).catch((error) => {
                  toast.error(error.data.user_msg || error.data.msg);
              })
            return;
        }
      });
    },
    closeConnectionReqPopupmethod(){
      bus.$emit('usrConnectionReqPopupStateBus', false)
      document.body.classList.remove('body_right_scroll_remove')
    }
  }
}